import {Site} from 'hooks/useSiteInfo/interfaces/Site';
import SiteTypeOption from '../interfaces/SiteTypeOption';
import SiteType from 'hooks/useSiteInfo/interfaces/SiteType';

interface SearchAndSortProps {
  filteredSearchValue: string;
  sites: Site[];
  selectedSiteTypeOption: SiteTypeOption;
}

export default function searchAndSort({
  filteredSearchValue,
  sites,
  selectedSiteTypeOption,
}: SearchAndSortProps): Site[] {
  //#region functionLogic

  const siteTypeGroup = {
    [SiteTypeOption.Retail]: [SiteType.Retail],
    [SiteTypeOption.Showroom]: [SiteType.Showroom],
    [SiteTypeOption.Distribution]: [SiteType.Distribution],
    [SiteTypeOption.Corporate]: [SiteType.Corporate, SiteType.Headquarters, SiteType.Office],
    [SiteTypeOption.DataCenter]: [SiteType.DataCenter, SiteType.Gwan],
    [SiteTypeOption.Lab]: [SiteType.Lab],
  };

  let filteredBySiteType: Site[] = [];

  if (selectedSiteTypeOption === SiteTypeOption.All) {
    filteredBySiteType = [...sites];
  } else {
    filteredBySiteType = sites.filter(site =>
      siteTypeGroup[selectedSiteTypeOption].includes(site.siteType)
    );
  }

  const splitSearch: string[] = filteredSearchValue.toLowerCase().split(' ');

  const siteCodeExactMatches: Site[] = filteredBySiteType.filter((item: Site) => {
    const isMatch: boolean = splitSearch.some(searchTerm => {
      return (
        item.siteCode.toString().toLowerCase() === searchTerm ||
        item.siteId.toLowerCase() === searchTerm
      );
    });

    return isMatch;
  });

  const combinedSearch: Site[] = filteredBySiteType.filter(item => {
    const isMatch: boolean = splitSearch.every(word => {
      return item.siteSearch.includes(word);
    });
    return !siteCodeExactMatches.includes(item) && isMatch;
  });

  //#endregion functionLogic

  const value = [...siteCodeExactMatches, ...combinedSearch];

  return value;
}
